import type { HttpClientConfig } from './http-client.types';

import {
  requestApiInterceptor,
  requestBearerTokenInterceptor,
  requestWebapiInterceptor,
  requestWebapiSettingsInterceptor,
} from './interceptors';

const baseInterceptors = [
  requestBearerTokenInterceptor,
];

export const apiClientConfig: HttpClientConfig = {
  requestInterceptors: [
    ...baseInterceptors,
    requestApiInterceptor,
  ],
};

export const httpClientConfig: HttpClientConfig = {
  requestInterceptors: [
    ...baseInterceptors,
  ],
};

export const webApiClientConfig: HttpClientConfig = {
  requestInterceptors: [
    ...baseInterceptors,
    requestWebapiInterceptor,
  ],
};

export const webApiSettingsClientConfig: HttpClientConfig = {
  requestInterceptors: [
    ...baseInterceptors,
    requestWebapiSettingsInterceptor,
  ],
};
